import useSWR from 'swr';

export default class APILicenses {

  getHeadersWithContentType(arg0: string | undefined): HeadersInit | undefined {
    throw new Error("Method not implemented.");
  }

  getURLSearchParams(object: any) {
    throw new Error("Method not implemented.");
  }

  fetcher(url: string) {
    throw new Error("Method not implemented.");
  }

  async createLicense(content: any) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/licenses/`, {
      method: 'POST',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify(content)
    });

    if (!response.ok) {
      return false;
    }

    const json = await response.json();
    return json;
  }

  async updateLicense(id: number, content: any) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/licenses/${id.toString()}`, {
      method: 'PATCH',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify(content)
    });

    return response.ok;
  }

  async deleteLicense(id: number) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/licenses/${id.toString()}`, {
      method: 'DELETE',
      headers: this.getHeadersWithContentType('application/json')
    });

    return response.ok;
  }

  useLicenses(query: any) {

    const params = this.getURLSearchParams(query);
    const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/api/licenses/?${params}`
    const { data, error, isLoading, mutate } = useSWR(endpoint, this.fetcher)

    return {
      data: data,
      error: error,
      isLoading: isLoading,
      mutate: mutate
    }
  }
}